import { getCookie } from "./cookie-utils";

/** Cookie names for AuthX-style session (replaces apiKey / sessionId). */
export const COOKIE_ACCESS_KEY = "accessKey";
export const COOKIE_REFRESH_KEY = "refreshKey";

export function getOlivsDatabaseIdHeader(_dbId) {
  // olivs-login zawsze wysyła "0" — nigdy nie używamy cookie/URL dla nagłówka database-id.
  return "0";
}

/** Headers required on OLIVS business API requests (fetch / manual calls). */
export function getOlivsAuthHttpHeaders(dbId) {
  const accessKey = getCookie(COOKIE_ACCESS_KEY);
  const refreshKey = getCookie(COOKIE_REFRESH_KEY);
  const out = {
    "database-id": getOlivsDatabaseIdHeader(dbId),
  };
  if (accessKey && accessKey !== "undefined") {
    out["access-key"] = accessKey;
  }
  if (refreshKey && refreshKey !== "undefined") {
    out["refresh-key"] = refreshKey;
  }
  return out;
}

/** Caller headers override inferred auth headers (needed for AuthX bootstrap requests). */
export function mergeOlivsAuthIntoHeaders(base, dbId) {
  const auth = getOlivsAuthHttpHeaders(dbId);
  return {
    ...auth,
    ...base,
    "browser-agent": window.navigator.userAgent,
  };
}
